const LocalStore = {

    user: null,
  
    IsAuthenticated: async function () {
      try {
        // console.log("enter to read data")
        const value = await localStorage.getItem("UserData");
        // console.log(value)
        if (value != null && value != '') {
          // value previously stored
          // console.log("value found")
          return true;
        }
        // console.log("return false")
        return false;
      } catch (e) {
        // error reading value
        // console.log("return false")
        return false;
      }
    },
  
    SaveData: async function (key, value) {
      // console.log("entered for save local data")
      try {
  
        await localStorage.setItem(key, value);
      } catch (e) {
        // saving error
        // console.log('error when saving  data to local store');
      }
    },
    LoadData: async function (key) {
      // console.log("entered for read local data")
  
      try {
        const value = await localStorage.getItem(key);
        // console.log(value)
        if (value !== null) {
          // value previously stored
          return value;
        }
      } catch (e) {
        // error reading value
        // console.log('error when reading  data to local store');
      }
    }
  
  }
  
  export default LocalStore;